import React, { createElement } from 'react'
import { handleImgixUrl } from '@kogk/common'
import FilmGrainImage from '../../../FilmGrainImage'
import { ImageType, RawType } from '../../types'
import cn from 'classnames'

const Image = (element: RawType, type: ImageType, key: number) => {
  const url = element.url ? handleImgixUrl(element.url).url() : ''
  const left = element.alt && element.alt.includes('image-left')
  const getAltText = () => (element.alt ? element.alt.replace('image-left', '').trim() : '')

  switch (type) {
    case 'film-grain':
      return createElement(
        'div',
        {
          key,
          className: cn('block-img', {
            'block-img--image-left': left
          })
        },
        <FilmGrainImage image={{ url, alt: getAltText() }} intensity={20} canvasId={element.url ?? element.type} />
      )
    default:
      return createElement(
        'div',
        {
          key,
          className: cn('block-img', {
            'block-img--image-left': left
          })
        },
        createElement('img', { src: url, alt: getAltText() })
      )
  }
}

export default Image
